<form class="form-horizontal row" #form="ngForm" (ngSubmit)="onSubmit()">
  <div class="form-group col-md-12">
    <label class="control-label col-sm-12">
      {{ 'Ticket Type' | translate }}
    </label>
    <div class="col-sm-12">
      <div class="select_box">
        <select class="form-control select" [(ngModel)]="editticket.ticket_type"
          (ngModelChange)="onSetType($event)" name="type" required>
          <option *ngFor="let type of ticket_types" value={{type.value}}>
            <span>{{type.label}}</span>
          </option>
        </select>
      </div>
    </div>
  </div>
  
  <div class="form-group col-md-12">
    <div class="row">
      <div class="col-md-6">
        <div *ngIf="editcategory != null" class="">
          <label class="control-label col-sm-12"><strong>{{ 'Category' | translate }}</strong></label>
          <label class="col-sm-12 mt-1">{{editcategory.name}}</label>
        </div>
      </div>
      <div class="col-md-6">
        <div *ngIf="editservice != null" class="">
          <label class="control-label col-sm-12"><strong>{{ 'Service' | translate }}</strong></label>
          <label class="col-sm-12 mt-1">{{editservice.name}}</label>
        </div>
      </div>
    </div>
  </div>
  
  <div *ngIf="editprovider != null" class="form-group col-md-12">
    <label class="control-label col-sm-12">{{ 'Provider' | translate }}</label>
    <div class="col-sm-12" [ngClass]="'select-providers'">
      <div class="table-responsive m-0">
        <table class="table table-bordered m-0" aria-label="contacttable">
          <thead>
          <tr class="tr-border-color">
            <th scope="col">
              {{ 'Name' | translate }}
            </th>
            <th scope="col">
              {{ 'Contact Name' | translate }}
            </th>
            <th scope="col">
              {{ 'Contact Phone' | translate }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr class="tr-border-color">
            <td>{{editprovider.name}}</td>
            <td>{{editprovider.contact_name}}</td>
            <td>{{editprovider.contact_phones}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="form-group col-md-12">
    <label class="control-label col-sm-12">
      {{ 'Typology of cancellation' | translate }} <span class="text-danger">*</span>
    </label>
    <div class="col-sm-12">
      <select class="form-control" (change)="onChangeTypology($event)" [(ngModel)]="cancellation_reason_typology" name="cancellation_reason_typology" required>
        <ng-container *ngFor="let sub of catalog_cancellation_reasons">
          <option [value]="sub.id">
            {{ sub.description }}
          </option>
        </ng-container>

      </select>
    </div>
  </div>

  <div class="form-group col-md-12">
    <label class="control-label col-sm-12">
      {{ 'Subtypology of cancellation' | translate }} <span class="text-danger">*</span>
    </label>
    <div class="col-sm-12">
      <select class="form-control" (change)="onChangeSubtypology($event)" [(ngModel)]="cancellation_reason_subtypology" name="cancellation_reason_subtypology" required>
        <ng-container *ngFor="let subt of catalog_subtypologies">
          <option [value]="subt.id">
            {{ subt.description }}
          </option>
        </ng-container>

      </select>
    </div>
  </div>

  <div class="form-group col-md-12">
    <label class="control-label col-sm-12">{{ 'Comment' | translate }}</label>
    <div class="form-group">
        <textarea
          rows="3" class="form-control"
          [(ngModel)]="editticket.comment" name="comment" required>
        </textarea>
    </div>
  </div>

  <!-- <div class="form-group col-md-12">
    <label class="control-label col-sm-12">
      {{ 'Dead service' | translate }} <span class="text-danger">*</span>
    </label>
    <div class="col-sm-12 ps-3">
      <label class="radio-inline">
        <input
          required
          type="radio"
          [(ngModel)]="isDeadService"
          name="is_dead_service" [value]="true">
        {{ 'Yes' | translate }}
      </label>
      <br>
      <label class="radio-inline">
        <input
          required
          type="radio"
          [(ngModel)]="isDeadService"
          name="is_dead_service" [value]="false">
        {{ 'No' | translate }}
      </label>
    </div>
  </div> -->

  <div class="footer-btns">
    <button
      type="button" class="btn secundary-btn btn secundary-btn-fw"
      (click)="onCancel()">
      {{ 'Cancel' | translate }}
    </button>
    <button
      type="submit" class="btn primary-btn btn primary-btn-fw"
      [disabled]="form.form.invalid || form.form.pending || isDisabled">
      {{ 'Save' | translate }}
    </button>
  </div>
</form>
